module.exports = __webpack_public_path__ + "img/block2-4.f9fb4554.svg";